import { render, staticRenderFns } from "./LogoWrapper.vue?vue&type=template&id=34f1bccc&"
import script from "./LogoWrapper.vue?vue&type=script&lang=js&"
export * from "./LogoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports